/** Payload for putSpecial — strips UI-only fields from list/card views. */
export const buildSpecialSavePayload = (special, overrides = {}) => {
  const {
    company,
    prettyRegularPrice,
    prettySpecialPrice,
    ...rest
  } = special || {};
  return { ...rest, ...overrides };
};

export const isSpecialActive = (special) => Number(special?.itemStatus) === 0;

/** Toggle partner deal active (0) ↔ inactive (2). */
export const getToggledItemStatus = (special) => (
  isSpecialActive(special) ? 2 : 0
);

/** Stable sort: active deals (itemStatus === 0) first, then inactive. */
export const sortSpecialsActiveFirst = (specials) => {
  if (!specials?.length) return [];

  const active = [];
  const inactive = [];

  specials.forEach((special) => {
    if (isSpecialActive(special)) {
      active.push(special);
    } else {
      inactive.push(special);
    }
  });

  return [...active, ...inactive];
};
